import { Svg, Path } from 'react-native-svg';

export const Minus = ({
    color,
    height,
    width,
    active = false,
    focused = false
}) => {
    return (
        <Svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <Path d="M15 9H3" stroke="#FF941A" strokeWidth="2" strokeLinecap="round" />
        </Svg>
    )
}